import React from 'react'
import moment from 'moment'
import { getUserFullName, getUserInitials } from 'helpers/getUserUIData'
import UserAvatarWithStats from 'app/components/UserAvatarWithStats'
import { ACTION_NAME_DID, EMOJIS } from 'app/constants/feed'
import TagIconSmall from 'app/components/SVGS/TagIconSmall'
import { NotificationsListItemPropType } from './NotificationsListItem.interface'

import './styles.scss'

const bc = 'notification-list-item'

const NotificationsListItem: React.FC<NotificationsListItemPropType> = ({ notification, t }) => {
  const isReaction = notification.emoji
  const isPeerInviteAccepted = notification.peerInvitedBy
  const userData = notification.user
  const { firstName, lastName, avatar, email } = userData
  const initials = getUserInitials(firstName, lastName, email)
  const fullName = getUserFullName(firstName, lastName)
  const { emoji, event, activityUserStory, timestamp } = notification
  const icon = EMOJIS.find(item => item.name === emoji)
  const eventName = event && event.name

  const getNotificationMessage = () => {
    let notificationTitle

    if (isReaction && eventName !== ACTION_NAME_DID) {
      notificationTitle = 'likes your story'
    } else if (isPeerInviteAccepted) {
      notificationTitle = 'accepted your invitation'
    } else if (eventName && eventName === ACTION_NAME_DID) {
      notificationTitle = 'finished a ProTrack'
    } else {
      notificationTitle = 'tagged you in a story'
    }

    return notificationTitle
  }

  const renderNotificationByType = (event, activityUserStory) => {
    if (eventName && event.id && ACTION_NAME_DID === eventName) {
      return <span className={`${bc}__action`}>{t('ProTrack is finished.', { proTrackName: event.activityName })}</span>
    }

    if (activityUserStory) {
      return <span className={`${bc}__question`}>{`${activityUserStory.activity.question} `}</span>
    }
    return null
  }

  return (
    <div className={bc}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__icon`}>
          <UserAvatarWithStats
            isReactionBoard
            avatar={avatar}
            initials={initials}
            circleProps={{
              cx: 20,
              cy: 20,
              strokeWidth: 2,
              r: 19,
            }}
          />
        </div>

        <div className={`${bc}__message`}>
          <div className={`${bc}__message-top`}>
            <span className={`${bc}__name`}>{fullName}</span>
            <p className={`${bc}__emoji--section`}>
              <span className={`${bc}__emoji`}>
                {isReaction && icon && React.createElement(icon.icon, { width: 13, height: 16 })}
                {!isReaction && !isPeerInviteAccepted && <TagIconSmall />}
              </span>
              {event && <span className={`${bc}__streak`}>{event.streak}</span>}
            </p>
            <div className={`${bc}__date`}>{moment(timestamp).fromNow()}</div>
          </div>

          <p className={`${bc}__reaction`}>{t(getNotificationMessage())}</p>
        </div>
      </div>
      {!isPeerInviteAccepted && (
        <div className={`${bc}__description`}>{renderNotificationByType(event, activityUserStory)}</div>
      )}
    </div>
  )
}

export default NotificationsListItem
